export default "__VITE_ASSET__DzTpcm0J__"